var React = require('react');

function Pause (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8 5V19M16 5V19","stroke":"#000000","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Pause.defaultProps = {"width":"800px","height":"800px","viewBox":"0 0 24 24","fill":"none"};

module.exports = Pause;

Pause.default = Pause;
